export function getView(is_saving) {
  return is_saving ? 'Loading' : 'Content'
}
